import billingService from '../../api/billing'

const state = {
  requests: []
}

const mutations = {
  setRequests (state, requests) {
    state.requests = requests
  }
}

const actions = {
  getRequests ({ commit }) {
    billingService.getRequests().then(response => {
      commit('setRequests', response.data)
    }).catch(error => {
      console.log(error)
    })
  },
  retryTransaction ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      billingService.retryTransaction(payload).then((res) => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
